export const SEARCH_NEWS_REQUEST_DATA = "SEARCH_NEWS_REQUEST_DATA";
export const SEARCH_NEWS_RECEIVE_DATA = "SEARCH_NEWS_RECEIVE_DATA";
export const SEARCH_NEWS_REQUEST_DATA_FAILED = "SEARCH_NEWS_REQUEST_DATA_FAILED";

export const receiveNewsData = (data) => ({ type: SEARCH_NEWS_RECEIVE_DATA, payload: data });
export const newsRequestFailed = (error) => ({ type: SEARCH_NEWS_REQUEST_DATA_FAILED, payload: error });
